<template>
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.33325 7.33333L5.99992 1.33333V4.66666C13.9686 4.66666 14.8879 11.1187 14.6666 14.6667C14.3319 12.8767 14.1766 10 5.99992 10V13.3333L1.33325 7.33333Z" stroke="#B5C6D8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
